import { SystemField } from "./system-field";

export class PurchaseBill extends SystemField{
     
     bill_num?:string;
     bill_to_id?:string;
     status?:string;
     amount_paid?:number;
     bill_date?:string;
     vendor_id?:string;
     sub_total?:number;
     total_discount?:number;
     vat_exem_total?:number;
     vat_tax_total?:number;
     balance?:number;
     due_balance?:number;
     total_balance?:number;
     vendor_location_id?:string;
     bill_type?:string;
     vendor_coa_id?:string;
     bill_from?:string;
}
